import type { Language } from '@/i18n/types';

// AdvisoryService.Type (ServicesModel.java), spelled out for ToR §6.4: "o consultație, o
// recomandare, un studiu, o vizită în fermă/teren, o consultanță tehnică online, o
// diagnosticare agronomică sau un plan de plantare".
export const SERVICE_TYPES = [
  'CONSULTATION',
  'RECOMMENDATION',
  'FARM_VISIT',
  'ONLINE_ADVICE',
  'DIAGNOSIS',
  'PLANTING_PLAN',
  'STUDY',
] as const;

const LABELS: Record<string, { ro: string; en: string }> = {
  CONSULTATION: { ro: 'Consultație', en: 'Consultation' },
  RECOMMENDATION: { ro: 'Recomandare', en: 'Recommendation' },
  FARM_VISIT: { ro: 'Vizită în fermă/teren', en: 'Farm/field visit' },
  ONLINE_ADVICE: { ro: 'Consultanță tehnică online', en: 'Online technical advice' },
  DIAGNOSIS: { ro: 'Diagnosticare agronomică', en: 'Agronomic diagnosis' },
  PLANTING_PLAN: { ro: 'Plan de plantare', en: 'Planting plan' },
  STUDY: { ro: 'Studiu', en: 'Study' },
};

/** Falls back to the raw code for a type added server-side before this map catches up. */
export function serviceTypeLabel(type: string, language: Language): string {
  return LABELS[type]?.[language] ?? type;
}
